export default __webpack_public_path__ + "static/media/samsung@2x.0f138ae7.jpg";